import { Grid } from '@mui/material'
import React from 'react'
import ContactDetails from './ContactDetails';
import ContactUs from './ContactUs';

function AllPageContact() {
  return (
    <Grid>
      <ContactDetails/>
      <ContactUs/>
    </Grid>
  )
}
export default AllPageContact;